//
// TooltipLinksController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "../../controllers/interactions/InteractionEvent";
import "../../models/visualElements/actions/AbstractAction";
import "../../controllers/ReportController";

var TooltipLinksController = createModule("BIRD::TooltipLinksController", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getLinksLabel: [7,4],
        getReportController: [1],
        performAction: [0,4],
        getInteractionEvent: [1,4],
        getActions: [[1]],
    },
    ,
    ,
]);
export default TooltipLinksController;
